import cx from 'classnames'
import isNumber from 'lodash/isNumber'

import Badge from 'common/components/Badge'
import { containsRtlChars } from 'common/helpers/string'
import { TextWithLineBreaks } from 'common/variantsUtils'

type Props = {
  index: number | undefined
  text: string
  className?: string
  isControlVariant: boolean
  isAiControlVariant?: boolean
}

const VariantCell = ({
  index,
  text,
  isControlVariant,
  isAiControlVariant,
  className,
}: Props) => {
  const hasRtlChars = containsRtlChars(text)

  const badgeClassName = cx('flex-none uppercase', {
    'ml-2': !hasRtlChars,
    'mr-2': hasRtlChars,
  })

  return (
    <div className={cx('flex items-center px-4 child-cell font-sm', className)}>
      {isControlVariant ? (
        <>
          <TextWithLineBreaks text={text} />
          <Badge
            size="small"
            className={badgeClassName}
            text="Control"
            variant="info"
          />
        </>
      ) : isAiControlVariant ? (
        <>
          <TextWithLineBreaks text={text} />
          <Badge
            size="small"
            className={badgeClassName}
            text="AI Control"
            variant="control"
          />
        </>
      ) : isNumber(index) ? (
        <div className="flex items-center">
          <span className={cx({ 'mr-4': !hasRtlChars })}>{`${
            index + 1
          }.`}</span>
          <TextWithLineBreaks text={text} />
        </div>
      ) : (
        <TextWithLineBreaks text={text} />
      )}
    </div>
  )
}

export default VariantCell
